module.exports = __webpack_public_path__ + "videos/tile-effects_jp.f2fa956.mp4";